import { atom } from 'recoil';
import { Environment } from '~/engine/data/Environment';
import { ViewManager } from '~/engine/view/ViewManager';
import { PlaneView } from '~/engine/view/views/PlaneView';

export const environmentState = atom<Environment | null>({
    key: 'environmentState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const viewManagerState = atom<ViewManager | null>({
    key: 'viewManagerState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const mainViewState = atom<PlaneView | null>({
    key: 'mainViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const upperSideViewState = atom<PlaneView | null>({
    key: 'upperSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});

export const lowerSideViewState = atom<PlaneView | null>({
    key: 'lowerSideViewState',
    default: null,
    dangerouslyAllowMutability: true,
});
